<template>
  <div class="w-full h-full">
    <router-view v-if="layoutLoaded" />
  </div>
</template>
<script>
import { EafTenantApi } from '@wiz-api/eaf-tenant-management'
import { EafProfileApi } from '@wiz-api/account'
import axios from 'axios'
import { forIn } from 'lodash'

export default {
  name: 'layout-fullscreen',
  data() {
    return {
      eafTenantApi: null,
      eafProfileApi: null,
      layoutLoaded: false,
      token: '',
      tenant: {
        id: '',
        name: '',
      },
      currentLanguage: 'zh',
    }
  },
  computed: {
    globalConfig() {
      return Wiz.globalSettings.globalConfig
    },
  },
  methods: {
    async getUserDetail() {
      const [err, res] = await this.eafProfileApi.getCurrentUserEafProfile()
      if (!err && res.userInfo) {
        const userInfo = {}
        forIn(res.userInfo, (value, key) => {
          const undderscoreKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
          userInfo[undderscoreKey] = value
        })
        await Wiz.AuthHooks.SetUserInfo({
          access_token: this.token,
          profile: { tenantName: this.tenant.name, tenantid: this.tenant.id, ...userInfo },
        })
      }
    },
    refreshToken() {
      this.token = localStorage.getItem('authorization')
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      Wiz.AuthHooks.SetUserInfo({
        access_token: this.token,
        profile: userInfo.profile,
        tenantConfig: userInfo.tenantConfig,
      })
    },
    storageTokenChange(e) {
      if (e.key === 'authorization') {
        this.refreshToken()
      }
    },
  },
  async created() {
    console.log('come in layout')
    // 初始化主题
    // const currentTheme = Wiz.globalSettings.layout?.config?.defaultTheme || 'light'
    // this.$store.dispatch('System/currentTheme', currentTheme)
    // document.getElementsByTagName('body')[0].className = `h-full ${currentTheme} saas`
    /**
     * 1. 获取url token
     * 2. 获取配置的租户信息
     * 2. 根据token获取用户信息，setUserInfo,给接口注入token
     * 3. 进入目标页面
     */
    if (window.__POWERED_BY_QIANKUN__) {
      this.token = localStorage.getItem('authorization')
      this.currentLanguage = localStorage.getItem('lang') === 'en' ? 'en' : 'zh'
      window.addEventListener('storage', this.storageTokenChange)
    } else if (this.$route.query.token) {
      const query = this.$route.query
      this.token = query.token
      delete query.token
      this.$router.replace({
        path: this.$route.path,
        query,
        params: this.$route.params,
      })
    } else {
      this.token = Wiz.AuthHooks.GetToken()
    }

    axios.defaults.headers.common.Authorization = `Bearer ${this.token}`
    this.tenant.id = JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || ''
    this.$i18n.locale = this.currentLanguage
    // this.token = Wiz.AuthHooks.GetToken()
    console.warn(this.token)
    if (!this.token) {
      await Wiz.AuthHooks.SetUserInfo(null)
      this.layoutLoaded = true
      return
    }
    await Wiz.AuthHooks.SetUserInfo({
      access_token: this.token,
    })

    this.eafTenantApi = new EafTenantApi()
    this.eafProfileApi = new EafProfileApi()
    // if (this.globalConfig.tenantName) {
    //   this.tenant.name = this.globalConfig.tenantName
    // }
    await this.getUserDetail()
    this.layoutLoaded = true
  },
  mounted() {
    // 全屏进入非全屏模块
    const appMainMicroi = document.getElementsByClassName('app-main-microi')
    const microiService = document.getElementById('MicroiService')
    if (
      this.$route.query.ShowClassicTop !== 'false' &&
      this.$route.query.ShowClassicLeft !== 'false'
    ) {
      if (microiService) {
        microiService.classList.remove('full-screen')
      }
      if (appMainMicroi) {
        appMainMicroi[0].classList.remove('full-screen')
      }
    }
  },
  destoryed() {
    window.removeEventListener('storage', this.storageTokenChange)
  },
}
</script>
